import { createContext, useContext } from 'react';
import type { TeacherDialog, TeacherDialogIds, TeacherDialogProps } from '../types';

export interface DialogsContextType {
    activeDialogs: Partial<Record<TeacherDialogIds, TeacherDialog>>;
    openDialog: (dialogId: TeacherDialogIds, props?: TeacherDialogProps) => void;
    hideDialog: (dialogId: TeacherDialogIds) => void;
    hideAllDialogs: () => void;
}

export const DialogsContext = createContext<DialogsContextType>({
    activeDialogs: {},
    openDialog: () => undefined,
    hideDialog: () => undefined,
    hideAllDialogs: () => undefined,
});

export const useDialogsContext = () => useContext(DialogsContext);
